'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('lodash');
var compose = require('../hoc/compose');
var template = require('./dropDownBase.rt');
var dropDownBaseOptions = require('./dropDownBaseOptions');
var displayNames = require('./displayNames');
var KEYS = require('../constants/keyCodes');
var PREVENT_DEFAULT_KEYS = _.pick(KEYS, ['LEFT', 'UP', 'RIGHT', 'DOWN', 'ENTER', 'SPACE', 'ESC']);

var doneScrolling = function doneScrolling(node, deltaY) {
    return node.scrollTop === 0 && deltaY < 0 || node.scrollTop + node.offsetHeight === node.scrollHeight && deltaY > 0;
};

var getChildrenHeight = function getChildrenHeight(node) {
    return _.reduce(node.children, function (acumm, child) {
        return acumm + child.offsetHeight;
    }, 0);
};

var DropDownBase = function (_React$Component) {
    _inherits(DropDownBase, _React$Component);

    function DropDownBase(props) {
        _classCallCheck(this, DropDownBase);

        var _this = _possibleConstructorReturn(this, (DropDownBase.__proto__ || Object.getPrototypeOf(DropDownBase)).call(this, props));

        _this.state = {
            isOpen: false,
            arrows: {
                up: false,
                down: false
            }
        };

        _this.isOpen = function () {
            return _this.props.customToggle ? _this.props.isOpen : _this.state.isOpen;
        };

        _this.toggleFunc = _this.props.customToggle ? _this.props.customToggle : function (isOpen) {
            return _this.setState({
                isOpen: _.isUndefined(isOpen) ? !_this.state.isOpen : isOpen
            }, _this.onToggle);
        };

        _this.toggleOptions = function (isOpen) {
            return _this.props.disabled ? _.noop() : _this.toggleFunc(isOpen);
        };

        _this.onToggle = function () {
            _this.optionsNode = _this.isOpen() ? ReactDOM.findDOMNode(_this.optionsPortal.refs.optionsInner) : null;
            _this.onLayoutChange();
            _this.registerLastWindowScrollPosition();
            _this.cancelOptionsScroll();
        };

        _this.updateArrow = function () {
            return _this.isOpen() ? _this.setState({ arrows: _this.getArrows() }) : _.noop();
        };

        _this.onLayoutChange = function () {
            if (_this.props.onLayoutChange) {
                _this.props.onLayoutChange(_this.getOptionsRect(), _this.optionsNode);
            }
            _this.arrowsTimer = window.setTimeout(function () {
                return _this.updateArrow();
            }, 0);
        };

        _this.getOptionsRect = function () {
            if (_this.optionsNode) {
                var selectedRect = ReactDOM.findDOMNode(_this.refs.selected).getBoundingClientRect();
                var optionsStyle = window.getComputedStyle(_this.optionsNode);
                var height = _this.optionsNode.scrollHeight;
                var width = selectedRect.width;
                if (_this.pendingHeightChange) {
                    _this.pendingHeightChange = false;
                    var padding = parseInt(optionsStyle.paddingTop, 10) + parseInt(optionsStyle.paddingBottom, 10);
                    height = getChildrenHeight(_this.optionsNode) + padding;
                }

                if (_this.props.keepOptionsWidth) {
                    var horizontalPadding = parseInt(optionsStyle.paddingLeft, 10) + parseInt(optionsStyle.paddingRight, 10);
                    width = Math.max(_this.optionsNode.offsetWidth - horizontalPadding, selectedRect.width);
                }
                return {
                    top: selectedRect.top + selectedRect.height,
                    left: selectedRect.left,
                    width: width,
                    height: height
                };
            }
        };
        _this.onWindowResize = function () {
            return _this.onLayoutChange();
        };

        _this.shouldBlockScroll = function (node, deltaY) {
            return doneScrolling(node, deltaY) || _this.props.customBlockScroll && _this.props.customBlockScroll(node, deltaY);
        };

        _this.handleArrowsScroll = function (deltaY) {
            var node = _this.optionsNode;
            var shouldScroll = _this.isOpen() && !_this.shouldBlockScroll(node, deltaY);
            if (shouldScroll) {
                node.scrollTop += deltaY;
            }
            _this.updateArrow();
        };

        _this.handleScroll = function (e) {
            if (_this.isOpen()) {
                var node = _this.optionsNode;
                var shouldBlockScroll = _this.shouldBlockScroll(node, e.deltaY) || !node.contains(e.target);
                if (shouldBlockScroll) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
            _this.updateArrow();
        };

        _this.registerLastWindowScrollPosition = function () {
            _this.lastWindowScrollPosition = {
                x: window.scrollX,
                y: window.scrollY
            };
        };

        _this.blockScrollOutOfWindow = function () {
            if (_this.isOpen()) {
                var _this$lastWindowScrol = _this.lastWindowScrollPosition,
                    x = _this$lastWindowScrol.x,
                    y = _this$lastWindowScrol.y;

                window.scrollTo(x, y);
            }
        };

        _this.getArrows = function () {
            var inner = _this.optionsNode;
            var up = inner && inner.scrollTop > 0;
            var down = inner && inner.scrollTop + inner.offsetHeight < inner.scrollHeight;
            return { up: up, down: down };
        };

        _this.handleKeyDown = function (e) {
            var isOpen = _this.isOpen();
            if (_this.props.onKeyDown) {
                _this.props.onKeyDown(e, isOpen);
            }

            if (isOpen) {
                var inputElementToAllowEvents = ReactDOM.findDOMNode(_this.props.inputToAllowEvents);
                var shouldAllowKeyDown = inputElementToAllowEvents === e.target;
                var isTargetContainedInOptions = _.isElement(_this.optionsNode) && _.isElement(e.target) && _this.optionsNode.contains(e.target);

                if (_(PREVENT_DEFAULT_KEYS).values().includes(e.keyCode) && !shouldAllowKeyDown && !isTargetContainedInOptions) {
                    e.stopPropagation();
                    e.preventDefault();
                }
                if (_.includes(_this.props.customCloseKeys || [KEYS.ENTER, KEYS.ESC, KEYS.SPACE], e.keyCode)) {
                    _this.toggleOptions(false);
                }
                _this.updateArrow();
            }
        };

        _this.onScroll = function (e) {
            if (_this.props.onOptionsScroll) {
                _this.props.onOptionsScroll(e);
            }
            _this.updateArrow();
        };

        _this.scrollOptions = function (dir) {
            var _this$state$arrows = _this.state.arrows,
                up = _this$state$arrows.up,
                down = _this$state$arrows.down;

            var SPEED = 5;
            _this.handleArrowsScroll(dir * SPEED);
            if (up && dir === -1 || down && dir === 1) {
                _this.scrollAnimationFrame = window.requestAnimationFrame(function () {
                    return _this.scrollOptions(dir);
                });
            }
        };

        _this.cancelOptionsScroll = function () {
            return window.cancelAnimationFrame(_this.scrollAnimationFrame);
        };

        _this.closeIfOpen = function () {
            return _this.isOpen() ? _this.toggleOptions(false) : _.noop();
        };

        _this.onClickOutside = function () {
            if (_this.props.closeOnClickOutside) {
                _this.closeIfOpen();
            }
        };
        _this.getOptionsProps = function () {
            return _.assign({}, _this.state, _this.props, { optionsStyle: _.omitBy(_this.props.optionsStyle, window.isNaN) }, _.pick(_this, ['scrollOptions', 'onScroll', 'cancelOptionsScroll', 'onClickOutside', 'registerLastWindowScrollPosition']));
        };

        var optionsMountPoint = null;
        _this.addOptionsMountPoint = function () {
            if (!optionsMountPoint) {
                optionsMountPoint = window.document.createElement('div');
                window.document.body.appendChild(optionsMountPoint);
            }

            return optionsMountPoint;
        };

        _this.removeOptionsMountPoint = function () {
            if (optionsMountPoint) {
                ReactDOM.unmountComponentAtNode(optionsMountPoint);
                window.document.body.removeChild(optionsMountPoint);
                optionsMountPoint = null;
            }
        };
        return _this;
    }

    _createClass(DropDownBase, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.node = ReactDOM.findDOMNode(this);
            if (this.props.onLayoutChange) {
                window.addEventListener('resize', this.onWindowResize);
            }
            if (this.props.blockScroll) {
                window.addEventListener('wheel', this.handleScroll);
                window.addEventListener('scroll', this.blockScrollOutOfWindow);
            }
            if (this.props.closeOnWindowBlur) {
                window.addEventListener('blur', this.closeIfOpen);
            }
            window.addEventListener('keydown', this.handleKeyDown, this.props.captureKeyboardEvents);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.onLayoutChange) {
                window.removeEventListener('resize', this.onWindowResize);
            }
            if (this.props.blockScroll) {
                window.removeEventListener('wheel', this.handleScroll);
                window.removeEventListener('scroll', this.blockScrollOutOfWindow);
            }
            if (this.props.closeOnWindowBlur) {
                window.removeEventListener('blur', this.closeIfOpen);
            }
            window.removeEventListener('keydown', this.handleKeyDown, this.props.captureKeyboardEvents);
            window.clearTimeout(this.arrowsTimer);
            this.cancelOptionsScroll();
            this.removeOptionsMountPoint();
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            var shouldCloseOptions = this.props.customToggle ? !nextProps.isOpen : !nextState.isOpen;
            if (shouldCloseOptions) {
                this.removeOptionsMountPoint();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.isOpen()) {
                var optionsMountPoint = this.addOptionsMountPoint();
                var options = React.createElement(dropDownBaseOptions, this.getOptionsProps());
                this.optionsPortal = ReactDOM.unstable_renderSubtreeIntoContainer(this, options, optionsMountPoint);
            }
            if (this.props.customToggle && prevProps.isOpen !== this.props.isOpen) {
                this.onToggle();
            }
            var selectedChanged = prevProps.selected.key ? prevProps.selected.key !== this.props.selected.key : prevProps.selected !== this.props.selected;
            if (selectedChanged) {
                this.toggleOptions(false);
            }

            if (this.props.options.length !== prevProps.options.length) {
                this.pendingHeightChange = true;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return template.call(this);
        }
    }]);

    return DropDownBase;
}(React.Component);

DropDownBase.displayName = displayNames.DROP_DOWN_BASE;

var nodeType = React.PropTypes.oneOfType([React.PropTypes.string.isRequired, React.PropTypes.node.isRequired, React.PropTypes.element.isRequired]);

DropDownBase.propTypes = {
    disabled: React.PropTypes.bool,
    optionsStyle: React.PropTypes.object,
    optionsInnerStyle: React.PropTypes.object,
    onLayoutChange: React.PropTypes.func,
    onOptionsScroll: React.PropTypes.func,
    onKeyDown: React.PropTypes.func,
    customBlockScroll: React.PropTypes.func,
    blockScroll: React.PropTypes.bool,
    blockClickOutside: React.PropTypes.bool,
    closeOnClickOutside: React.PropTypes.bool,
    displayArrow: React.PropTypes.bool,
    captureKeyboardEvents: React.PropTypes.bool,
    closeOnWindowBlur: React.PropTypes.bool,
    customToggle: React.PropTypes.func,
    isOpen: React.PropTypes.bool,
    keepOptionsWidth: React.PropTypes.bool,
    inputToAllowEvents: React.PropTypes.object, // React Ref
    customCloseKeys: React.PropTypes.arrayOf(React.PropTypes.number),
    selected: nodeType,
    options: nodeType
};

DropDownBase.defaultProps = {
    disabled: false,
    closeOnClickOutside: true,
    displayArrow: true,
    captureKeyboardEvents: true,
    blockClickOutside: true,
    closeOnWindowBlur: true,
    keepOptionsWidth: false
};

module.exports = compose(DropDownBase);


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/dropDownBase.js